<template>

    <CascoAjanlatBase :titleExtra="titleExtra">

        <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatok">

            <v-layout row wrap>

              <BnFormField :attributes="tf_gfb_kar"/>

              <BnFormField :attributes="tf_casco_kar"/>

              <BnFormField :attributes="tf_nem_rend_kar"/>

              <BnFormField :attributes="tf_lopas_kar"/>

              <BnFormField v-if="extraVisible()" :attributes="waberer_extrak_felsorolas" />

            </v-layout>

        </v-form>

    </CascoAjanlatBase>

</template>

<script>

import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';

export default {
    name: 'AjanlatAdatokB16_V0',
    components: { CascoAjanlatBase, BnFormField },
    mixins: [cascoOfferData],
    methods: {
        extraVisible() {
            return parseInt(this.$store.getters.tarifaData.aegon_extrak_osszertek, 10) > 0;
        },
    },
    version: 'v0',
    data() {
        return {
            tf_gfb_kar: {
                type: 'text',
                label: 'Korábban GFB alapján rendezett károk száma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'tf_gfb_kar',
                path: 'tarifaData.elozo_karok.tf_gfb_kar',
            },
            tf_casco_kar: {
                type: 'text',
                label: 'Korábban CASCO alapján rendezett károk száma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'tf_casco_kar',
                path: 'tarifaData.elozo_karok.tf_casco_kar',
            },
            tf_nem_rend_kar: {
                type: 'text',
                label: 'Korábbi biztosító által nem rendezett esemény darabszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'tf_nem_rend_kar',
                path: 'tarifaData.elozo_karok.tf_nem_rend_kar',
            },
            tf_lopas_kar: {
                type: 'text',
                label: 'Korábbi teljes gépkocsi lopáskár darabszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'tf_lopas_kar',
                path: 'tarifaData.elozo_karok.tf_lopas_kar',
            },
            waberer_extrak_felsorolas: {
                type: 'text',
                label: 'Szérián kívüli extrák felsorolása',
                visible: true,
                editable: true,
                help: true,
                mezo: 'waberer_extrak_felsorolas',
                path: 'tarifaData.waberer_extrak_felsorolas',
            },
        };
    },
};
</script>
